"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _WhiteButton = _interopRequireDefault(require("./WhiteButton.style"));

var _Icon = _interopRequireDefault(require("../Icon"));

var renderIcon = function renderIcon(icon) {
  if (!icon) {
    return null;
  }

  if (_react.default.isValidElement(icon)) {
    return icon;
  }

  return _react.default.createElement(_Icon.default, icon);
};

var WhiteButton = function WhiteButton(props) {
  var iconPosition = props.iconPosition,
      text = props.text,
      children = props.children,
      icon = props.icon,
      other = (0, _objectWithoutProperties2.default)(props, ["iconPosition", "text", "children", "icon"]);
  return _react.default.createElement(_WhiteButton.default, other, iconPosition === 'left' && renderIcon(icon), text || children, iconPosition === 'right' && renderIcon(icon));
};

WhiteButton.propTypes = {
  text: _propTypes.default.string,
  icon: _propTypes.default.oneOfType([_propTypes.default.shape(_Icon.default.propTypes), _propTypes.default.element]),
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  style: _propTypes.default.object,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['bordered', 'filled', 'grey']),
  borderType: _propTypes.default.oneOf(['solid', 'dashed']),
  size: _propTypes.default.oneOf(['medium', 'large']),
  status: _propTypes.default.oneOf(['normal', 'success', 'danger', 'grey'])
};
WhiteButton.defaultProps = {
  text: '',
  icon: null,
  iconPosition: 'left',
  style: {},
  onClick: function onClick() {},
  disabled: false,
  type: 'bordered',
  borderType: 'solid',
  size: 'large',
  status: 'normal'
};
var _default = WhiteButton;
exports.default = _default;